module.exports = {
	"DEFAULT_IMAGE": "images/no_image_available.jpeg",
	"DEFAULT_IMAGE_DETAILS_PAGE": "images/details_page_default_image.jpg",
	"DEFAULT_IMAGE_DETAILS_PAGE_UP": "images/details_page_default_image_up.jpg",
	"DEFAULT_IMAGE_DETAILS_PAGE_DOWN": "images/details_page_default_image_down.png",
	"GRID_IMAGE": "images/noImage.jpg"
};


/** WEBPACK FOOTER **
 ** ./html/default.json
 **/